import { ROUTER_NAMES } from '../routerNamesConfig'
import { PREDEFINED_RANGES_MAP } from '@/config/predefined-ranges'

export const FIELDS_CARD_CONFIG = {
	path: 'field/:cardId',
	name: ROUTER_NAMES.FIELDS.CARD,
	component: () => import('@/views/company/cards/field/CompanyCardFieldView.vue'),
	children: [
		{
			path: '',
			name: ROUTER_NAMES.FIELDS.CARD_TABS.GENERAL,
			component: () =>
				import('@/views/company/cards/field/tabs/CompanyCardFieldGeneralTabView.vue'),
		},
		{
			path: 'documents',
			name: ROUTER_NAMES.FIELDS.CARD_TABS.DOCUMENTS,
			component: () =>
				import('@/views/company/cards/field/tabs/CompanyCardFieldDocumentsTabView.vue'),
		},
		{
			path: 'finance',
			name: ROUTER_NAMES.FIELDS.CARD_TABS.FINANCE,
			component: () =>
				import('@/views/company/cards/field/tabs/CompanyCardFieldFinanceTabView.vue'),
		},
		{
			path: 'crop_rotations',
			name: ROUTER_NAMES.FIELDS.CARD_TABS.CROP_ROTATIONS,
			component: () =>
				import('@/views/company/cards/field/tabs/CompanyCardFieldCropRotationsTabView.vue'),
		},
		{
			path: 'crop_conditions',
			name: ROUTER_NAMES.FIELDS.CARD_TABS.CROP_CONDITIONS,
			component: () =>
				import('@/views/company/cards/field/tabs/CompanyCardFieldCropsConditionTabView.vue'),
		},
		{
			path: 'meteo',
			name: ROUTER_NAMES.FIELDS.CARD_TABS.METEO,
			component: () => import('@/views/company/cards/field/tabs/CompanyCardFieldMeteoTabView.vue'),
		},
		{
			path: 'works',
			name: ROUTER_NAMES.FIELDS.CARD_TABS.WORKS,
			component: () => import('@/views/company/cards/field/tabs/CompanyCardFieldWorksTabView.vue'),
		},
		{
			path: 'writeoffs',
			name: ROUTER_NAMES.FIELDS.CARD_TABS.WRITEOFFS,
			component: () =>
				import('@/views/company/cards/field/tabs/CompanyCardFieldWriteOffsTabView.vue'),
			meta: { cardDefaultPeriod: PREDEFINED_RANGES_MAP.THIS_YEAR },
		},
		{
			path: 'yield',
			name: ROUTER_NAMES.FIELDS.CARD_TABS.YIELD,
			component: () => import('@/views/company/cards/field/tabs/CompanyCardFieldYieldTabView.vue'),
		},
		{
			path: 'agrochem',
			name: ROUTER_NAMES.FIELDS.CARD_TABS.AGROCHEM,
			component: () =>
				import('@/views/company/cards/field/tabs/CompanyCardFieldAgrochemTabView.vue'),
		},
	],
}
